import type { FC } from "react";

import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { DataFormat } from "../../../../components/ChannelsOverviewBarChart/ChannelsOverviewBarChartContainerFormat";
import { percentDataFormat } from "../../../../components/ChannelsOverviewBarChart/ChannelsOverviewBarChartContainerFormat";
import ViewByDomainChart from "../../../../components/ChannelsOverviewBarChart/components/view-by-domain-chart/ViewByDomainChart";
import { EViewBySwitcherItems } from "../../../../components/ChannelsOverviewBarChart/components/view-by-switcher/ViewBySwitcher";
import type { ISeries } from "../../../../components/ChannelsOverviewBarChart/types";
import { BetaTrafficSourceDisplayMap } from "../../../consts";
import type { IChannelsBetaData } from "../../../types/types";

import BetaChannelsChart from "./BetaChannelsChart";

const ViewByDomainChartContainer = styled.div`
    margin-top: 32px;
`;

const ChartContainer = styled(FlexRow)`
    margin-top: 32px;
    min-height: 313px;
`;

const BetaChartViewContent: FC<{
    viewBy: number;
    series: ISeries[];
    config: any;
    totalVisits: number;
    data: IChannelsBetaData;
    dataFormat: DataFormat;
}> = ({ viewBy, series, config, totalVisits, data, dataFormat }) => {
    return viewBy === EViewBySwitcherItems.Channels ? (
        <BetaChannelsChart
            series={series}
            config={config}
            totalVisits={totalVisits}
            data={data}
        />
    ) : (
        <ViewByDomainChartContainer>
            <ViewByDomainChart
                trafficSourcesMap={BetaTrafficSourceDisplayMap}
                data={data}
                isPercentageDataMode={dataFormat === percentDataFormat}
            />
        </ViewByDomainChartContainer>
    );
};

export default BetaChartViewContent;
